import { api } from 'webReservations/api';

interface GuestCounts {
  minGuests: number;
  maxGuests: number;
}

export type AvailableDatesForRestaurant = Record<string, GuestCounts>;

export const getAvailableDatesForRestaurant = async (
  restaurantId: string,
): Promise<AvailableDatesForRestaurant> =>
  api.get(`/restaurants/${restaurantId}/available-dates`);
